import React, {useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { downloadBook } from '../util/index.js';

import { SnackBar } from  './general';
import { getMultipleProducts } from '../services/products.js';
import { postCheckoutBook } from '../services/booking.js'

import dayjs from "dayjs"


const styleObj = {
    checkProd: {
      marginLeft: 15
    },
    delDialogLeft: {
      minWidth: '60%',
      width:'100%',
    },
    delDialogCont: {
      display: 'flex',
      padding:20
    },
    delDialogRight: {
      width: '40%'
    },
    textarea: {
      width: '90%'
    },
    indNoteCont: {
      marginBottom: '5px'
    },
    noteTitle:{
      fontWeight: 'bold',
      fontSize: '14px',
      textDecoration: 'underline'
    },
    note: {
      fontSize: '14px'
    },
    adv: {
      marginBottom: '10px',
      color: 'green'
    },
    dis: {
      marginBottom: '10px',
      color: '#e1ad01'
    },
    amt: {
      marginBottom: '10px',
      color: '#a0522d'
    },
    bal: {
      marginBottom: '10px',
      color: 'red'
    }
  };

  const AllNotes = ({bookingNote}) => {
    
      return(
        <Stack sx={{width: '90%'}}>
          <Typography sx={{fontWeight: 'bold', fontSize: 16, textDecoration: 'underline', mb:1}}>Notes</Typography>
        {bookingNote && (
          <Stack>
            <Typography sx={{fontWeight:'bold', fontSize: 14}}>Booking Notes</Typography>
            <Typography sx={{ml:2, fontSize:13}}>{bookingNote}</Typography>
          </Stack>
        )}
        </Stack>
      )
    
    
  }


  const Notes = ({currentNote, setCurrentNote, bookingNote}) => {
    return (
      <>
        <AllNotes bookingNote={bookingNote}/>
        {(<><Typography variant="subtitle2" component="div"  sx={{fontWeight:'bold', fontSize: 14}}> Checkout Note</Typography>
          <TextField
            multiline
            aria-label="empty textarea"
            minRows={3}
            key='txt-area'
            value={currentNote}
            onChange={(e)=>{setCurrentNote(e.target.value)}}
            placeholder={"Checkout Notes"}
            sx={styleObj.textarea}
          /></>)}
      </>

    )
  }

  const Actions = ({setChecks, checkWarn, setCheckWarn, setCheckError, checks, doCheckout, setCurrentNote, setOpenPostCheckout, saveLoad}) => {
    const handleAction = () => {
        const validateCheckoutCheckBox = () => {
            return Object.values(checks).filter(check=> check===true)
        }
        return () => {
            const checkedBoxes = validateCheckoutCheckBox();
            const isAllChecked = checkedBoxes.length === Object.values(checks).length;
            const isAnyChecked = checkedBoxes.length > 0
            if (!isAnyChecked) {
                setCheckError(true)
                return
            }
            if (isAllChecked || checkWarn) {
                doCheckout(checks);
                setChecks(checks)
                setCheckWarn(false)
            } else {
                setChecks(checks)
                setCheckWarn(true)
            }
        }
    }
      
    return([
        <Button key="back" variant="outlined" disabled={saveLoad} onClick={()=>{setChecks({}); setCurrentNote(''); setOpenPostCheckout(false);}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
        <Button key="checkout" variant="contained" disabled={saveLoad} onClick={handleAction()} endIcon={<LogoutIcon/>}>Checkout </Button>
    ])
      
  }

  const Body = ({currentNote, setCurrentNote, advance, setAdvance, productDetails, handleLabelClick, checkError, setCheckError, checkWarn, setCheckWarn, checks, bookingNote, products}) => {
    
    return (
      <div style={styleObj.delDialogCont}>
        <div style={styleObj.delDialogLeft}>          
          {productDetails.map(product=><IndProdCheck key={`check-${product._id}`} checks={checks} product={product} handleLabelClick={handleLabelClick} checkError={checkError} setCheckError={setCheckError} checkWarn={checkWarn} setCheckWarn={setCheckWarn} items={products.find(prod => prod._id === product._id)?.items}/>)}
        </div>
        <div style={styleObj.delDialogRight}>
        <div style={{marginBottom:'10px'}}> <TextField  value={advance} onChange={(e)=>{setAdvance(e.target.value)}} label="Advance (₹)" /></div>
        <Notes currentNote={currentNote} setCurrentNote={setCurrentNote} bookingNote={bookingNote}/>
        </div>
      </div>
    )
  }

  const IndProdCheck = ({product, handleLabelClick, checkWarn, setCheckWarn, checkError, setCheckError, checks, items}) => {
    return (
      <div>
        <Stack direction="row" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom component="div">{product.name}</Typography>
          <Typography sx={{ ml: 2 }} variant="body" gutterBottom component="div">({items.map(item=>item.sku).join(",")})</Typography>
        </Stack>
        <CheckBoxes product={product} handleLabelClick={handleLabelClick} checks={checks} count={items.length}/>
        <SnackBar message={'You must select at least one item'} open={checkError} handleClose={()=>{setCheckError(false)}} severity={"error"}/>
        <SnackBar message={'CheckList is not complete. If you want to checkout with partial list, click checkout again'} open={checkWarn} severity={"warning"}/>
      </div>
    )
  }

  const CheckBoxes = ({product, checks, handleLabelClick, count}) => {    
    return (
        <FormGroup sx={styleObj.checkProd}>
            {product.includes.map(incl=> (<FormControlLabel control={<Checkbox onChange={handleLabelClick(incl?.item, product._id)} checked={checks[incl?.item?.replace(/ /g, '_')]}/>} label={`${parseInt(incl?.count)*count} x ${incl?.item} `} />))}
        </FormGroup>
    )
  }

const PostCheckout = ({open, advance, products, setAdvance,  bookingNote, setOpenPostCheckout, fromDate, toDate, tenant, amount, discount, billableDates, saveLoad, setSaveLoad, setBookingAdded, setBookingError, handleCloseButton}) => {
                
    const [productDetails, setProductDetails] = useState([])
    const [checks, setChecks] = useState({})
    const [checkWarn, setCheckWarn] = useState(false);
    const [checkError, setCheckError] = useState(false);
    const [currentNote, setCurrentNote] = useState('')
    
    useEffect(()=>{
      const getData = async () => {        
        const ids = products.map(x=>x._id)
        const data = await getMultipleProducts(ids);
        setProductDetails(data)

        const items = data.flatMap(x=>x.includes.map(inc=>x._id + '_' + inc.item.replace(/ /g, '_')))
        let _checks = {};
        items.forEach(item=> {
            _checks[item] = false
        })
        setChecks(_checks)
      }
      if (open) {
        getData()
      }
        return () => {
            setCheckWarn(false)
            setCheckError(false)
            setChecks([])
        }
    }, [open])

    const handleLabelClick = (item, id) => {      
      if (item) {
        return (event) => {
          let _checks  = {...checks};
          _checks[id + '_' + item.replace(/ /g, '_')] = event.target.checked
          setChecks(_checks)
        };
      }
    }

    const doCheckout = async() => {
       const data = {
            from: fromDate.utc().toISOString(),
            to: toDate.utc().toISOString(),
            tenant: tenant.userId,
            products: products.map(item=>{return{id: item._id, count: item.count, items: item.items}}),
            note: bookingNote,
            checkoutNotes: currentNote,
            amount: amount,
            discount: discount,
            advance: advance,
            billableDates: billableDates,
            checks:checks,
          }          
          try {
            setSaveLoad(true)
            const resp = await postCheckoutBook(data)
            downloadBook(resp)
            setSaveLoad(false)
            setBookingAdded()
            handleCloseButton();
          } catch (e) {
            console.log(e)
            setSaveLoad(false)
            setBookingError('Could not book')
          }
    }
    return (
        <Box>
            <Divider />
            <Body
                checkWarn={checkWarn}
                setCheckWarn={setCheckWarn}
                currentNote={currentNote}
                advance={advance}
                setAdvance={setAdvance}
                setCurrentNote={setCurrentNote}
                productDetails={productDetails}
                handleLabelClick={handleLabelClick}
                checkError={checkError}
                setCheckError={setCheckError}
                checks={checks}
                bookingNote={bookingNote}
                products={products}
                saveLoad={saveLoad}
            />
            <Divider />
            <DialogActions>
                <Actions
                    setCheckWarn={setCheckWarn}
                    checkWarn={checkWarn}
                    setChecks={setChecks}
                    setCurrentNote={setCurrentNote}
                    setCheckError={setCheckError}
                    checks={checks}
                    setOpenPostCheckout={setOpenPostCheckout}
                    doCheckout={doCheckout}
                    saveLoad={saveLoad}
                />
            </DialogActions>
        </Box>
    )
  }


  export default PostCheckout
